import _isNil from 'lodash/isNil'
import { WidgetItem } from '../../interfaces/TournamentsConfig'

let tournamentInfo: WidgetItem = {}

export const COLUMN_ID = {
  RANK: 'rank',
  NAME: 'name',
  SCORE: 'score',
  REWARD: 'reward'
}

export const LEADERBOARD = 'Leaderboard'
export const TOURNAMENT = 'Tournament'

export const DISABLE_NX_TOURNAMENT_DETAILS_BUTTON = 'DISABLE_NX_TOURNAMENT_DETAILS_BUTTON'

export function setNXTournamentInfo(data: WidgetItem) {
  if (_isNil(data)) {
    return
  }
  tournamentInfo = data
}

export function setNumRegistrations(data: any) {
  if (_isNil(data)) {
    return
  }
  tournamentInfo = { ...tournamentInfo, numRegistrations : data }
}

export function isNxSlotsAvailable() {
  const { numRegistrations=0, maxParticipants=0 } = tournamentInfo || {}
  return maxParticipants > numRegistrations
}

export function getNXTournamentInfo(): WidgetItem {
  return tournamentInfo
}
